import { useEffect } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useUser, LoginState } from '@hooks/useUser';
import { Catalog } from '@components/Catalog';
import { DoNotUseDialog } from '@components/DoNotUseDialog/DoNotUseDialog';
import { Landing } from '@components/Landing';
import { Loading } from '@components/shared/Loading';
import { login } from '@lib/auth';

const Container = styled.div`
  width: 100%;
`;

const Index = () => {
  const { loginState } = useUser();
  const loggedIn = loginState === LoginState.LOGGEDIN;
  const isLoading = loginState === LoginState.AWAITING_LOGIN;

  const router = useRouter();
  const isRoutingToLogin = router.query.switchAccounts;

  useEffect(() => {
    if (isRoutingToLogin) {
      login();
    }
  }, [loggedIn, isRoutingToLogin]);

  if (loggedIn) {
    return (
      <Container className="encore-creator-light-theme encore-layout-themes">
        <DoNotUseDialog />
        <Catalog />
      </Container>
    );
  }

  return isLoading || isRoutingToLogin ? (
    <Container className="encore-creator-light-theme">
      <Loading size="lg" data-screen="index" />
    </Container>
  ) : (
    <Landing />
  );
};

export default Index;
